import { render, staticRenderFns } from "./fundManagement.vue?vue&type=template&id=5553a686"
import script from "./fundManagement.vue?vue&type=script&lang=js"
export * from "./fundManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports